import AccessManagementTabs from '../screens/AccessMangementTabs'
import FeatureFlagBulkUpdate from '../screens/FeatureFlagBulkUpdate'
import RoleManagementForm from '../screens/RoleManagementForm'
import UserPermissions from '../screens/UserPermissions'
import UserForm from '../screens/userManagement/userForm'
import { ROLE, RouteWithAccessType } from './types'

const accessManagementPagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/access-management/:page',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: [
      'access.role.view',
      'access.feature.flag.view',
      'access.user.view',
      'access.bulk.view'
    ],
    component: <AccessManagementTabs />,
    tabs: [
      {
        params: { page: 'role-management' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['access.role.view']
      },
      {
        params: { page: 'feature-flag' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['access.feature.flag.view']
      },
      {
        params: { page: 'user-management' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['access.user.view']
      },
      {
        params: { page: 'bulk-access' },
        rolesListWithReadAccess: [ROLE.ADMIN],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['access.bulk.view']
      }
    ]
  },
  {
    route: '/access-management/feature-flag/bulk-update',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['access.feature.flag.bulk.update'],
    component: <FeatureFlagBulkUpdate />
  },
  {
    route: '/access-management/role-management/create',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['access.role.create'],
    component: <RoleManagementForm />
  },
  {
    route: '/access-management/role-management/:roleID/edit',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['access.role.edit'],
    component: <RoleManagementForm />
  },
  {
    route: '/access-management/user-management/create',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['access.user.manage'],
    component: <UserForm />
  },
  {
    route: '/access-management/user-management/user/:id',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['access.user.view'],
    component: <UserForm />
  },
  {
    route: '/access-management/user-management/user/:id/permissions',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['access.permission.view'],
    component: <UserPermissions />
  }
]

export default accessManagementPagesRoleManagement
